export default __webpack_public_path__ + "200a7be.png";